let add_cal_event = ( function( $ ) {

	let $containers;

	let _init = function() {
		$containers = $( 'div.add-cal-event' );

		$containers.each( _setup_cal_links );
	};

	let _setup_cal_links = function() {
		let title       = $( this ).data( 'event-title' ),
			duration    = $( this ).data( 'event-duration' ),
			start       = $( this ).data( 'event-start' ),
			// end         = $( this ).data( 'event-end' ),
			description = $( this ).data( 'event-description' ),
			location    = $( this ).data( 'event-location' );

		var calendar_link = createCalendar({
			options: {
				class: 'event-cal-links'
			},
			data: {
				title: title,
				start: new Date( start ),
				duration: duration,
				address: location,
				description: description
			}
		});

		$( this ).append( calendar_link );

		_setup_link_toggle( $( this ) );
	};

	var _setup_link_toggle = function( $parent ) {
		$parent.find( 'a.toggle-add-actions' ).on ( 'click', function( e ) {
			e.preventDefault();

			var $cal_links = $parent.find( '.event-cal-links' );

			$cal_links.slideToggle();
			$cal_links.toggleClass( 'open' );
		} )
	};

	if ( $( 'div.add-cal-event' ).length > 0 ) {
		_init();
	}

	return {
	}

} ) ( jQuery );

module.exports = add_cal_event;